import { useState, useEffect, useCallback, useRef } from 'react';
import { auth } from '../../config/firebaseConfig';
import { useUserProfile } from '../../contexts/UserProfileContext';
import { fetchPendingAssignments } from '../../utils/assignmentDeadlines';
import { sendDeadlineReminders } from '../../utils/assignmentReminders';

/**
 * Giriş yapan kullanıcının tamamlanmamış kalite/eğitim atamalarını yükler,
 * son 2 güne girenler için uyarı mesajlarını (kişi + SMO Lead + bölge müdürü)
 * bir kez gönderir ve arayüzün ihtiyaç duyduğu özeti döner.
 */
const useAssignmentAlerts = () => {
  const { employeeData, employeeId, isLoading } = useUserProfile();
  const [assignments, setAssignments] = useState([]);
  const [loaded, setLoaded] = useState(false);
  // Uyarı gönderimi oturum başına bir kez denenir
  const remindersDispatchedFor = useRef(null);

  const load = useCallback(async () => {
    const authUid = auth.currentUser?.uid;
    const role = employeeData?.role;
    if (!authUid || !employeeId) return;

    try {
      const pending = await fetchPendingAssignments(role, authUid);
      setAssignments(pending);
      setLoaded(true);

      // Son 2 güne girmiş atamalar için uyarıları gönder
      if (remindersDispatchedFor.current !== employeeId) {
        remindersDispatchedFor.current = employeeId;
        sendDeadlineReminders(
          pending,
          { id: employeeId, ...employeeData },
          auth.currentUser?.email
        ).catch((error) => console.error('Uyarı gönderimi başarısız:', error));
      }
    } catch (error) {
      console.error('Atamalar yüklenemedi:', error);
      setLoaded(true);
    }
  }, [employeeData, employeeId]);

  useEffect(() => {
    if (isLoading) return;
    load();
  }, [isLoading, load]);

  const dueSoon = assignments.filter((item) => item.dueSoon);
  const unreadSOPs = assignments.filter((item) => item.type === 'SOP');

  return {
    assignments,
    dueSoon,
    unreadSOPs,
    loaded,
    refresh: load,
  };
};

export default useAssignmentAlerts;
